export default __webpack_public_path__ + "bbcdfb0.png";